import { useState, useEffect, useCallback } from 'react';
import { DisplayPollingService, DisplayPollingStatus } from '../services/DisplayPollingService';

/**
 * useDisplayPolling Hook
 * 
 * React hook for subscribing to display polling updates.
 * Provides a clean interface to the DisplayPollingService.
 */
export const useDisplayPolling = () => {
  const [status, setStatus] = useState<DisplayPollingStatus>({
    state: 'unregistered',
    isPolling: false
  });
  
  useEffect(() => {
    // Subscribe to polling service updates
    DisplayPollingService.subscribe(setStatus);
    
    return () => {
      // Cleanup subscription on unmount
      DisplayPollingService.unsubscribe(setStatus);
    };
  }, []); // No complex dependencies!
  
  const startRegistrationPolling = useCallback((clientId: string) => {
    DisplayPollingService.startRegistrationPolling(clientId);
  }, []);
  
  const startActivationPolling = useCallback((clientId: string, registrationData: any) => {
    DisplayPollingService.startActivationPolling(clientId, registrationData);
  }, []);
  
  const stopPolling = useCallback(() => {
    DisplayPollingService.stopPolling();
  }, []);
  
  return {
    status,
    startRegistrationPolling,
    startActivationPolling,
    stopPolling
  };
}; 